// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { projectSchema } from '@/project/api/types';
import { z } from 'zod';

const responseSchema = z
  .object({ data: projectSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, project: data }));

/**
 * Deletes an existing asset project assignment.
 *
 * @param projectKey - The project key of the assignment.
 * @param assignmentKey - The assignment key of the assignment.
 */
export async function deleteAssetProjectAssignment(
  projectKey: string,
  assignmentKey: string
) {
  const path = `/v1/project/${projectKey}/segment/${assignmentKey}`;
  const response = await api.delete(path);

  return parseResponse(responseSchema, response.data, {
    schemaName: 'DeleteAssetProjectAssignment',
    endpoint: path,
  });
}
